<template>
  <div class="client-bids min-vh-100">
    <div class="container-fluid client">
      <div class="clientWrap">
        <div class="row">
          <div class="col-md-12 py-4 text-left">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Users</h1>
              <button
                class="btn btn-icn ms-auto"
                @click="showClientModal()"
                v-if="isAdmin || isRep"
              >
                <i class="fa fa-plus"></i> Create New User
              </button>
            </div>  
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="dark-filter w-100 p-1 mb-2 d-inline-block">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="ml-3 m-0">Filters</h5>
                <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i
                    class="fa"
                    v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']"
                  ></i>
                  {{ showFilters ? 'Hide' : 'Show' }} Filters
                </span>
              </div>
              <div class="row p-4" v-if="showFilters">
                <div class="col-lg-12">
                  <form class="row">

                      <div class="col-md-6 col-lg-3">
                          <label for="filter" class="">User</label>
                          <!-- <multiselect
                            v-model="selectedClient"
                            placeholder="Select"
                            :options="allClients"
                            :multiple="false"
                            label="clientFullName"
                           
                            track-by="id"
                          ></multiselect> -->
                          <!-- <select class="form-control" v-model="searchText">
                            <option value="" disabled selected>Select User</option>
                            <option v-for="client in allClients" :key="client.firstName" :value="client.firstName + ' ' + client.lastName">
                              {{ client.firstName }} {{ client.lastName }}
                            </option>
                          </select> -->

                          <input type="text" class="form-control" placeholder="Search by Name" v-model="searchText">
                      </div>
                    <div class="col-md-6 col-lg-3">
                      <label for="filter" class="">Type</label>
                      <select v-model="clientType" class="form-control" style="height: 40px;" >
                          <option value="">SELECT</option>
                          <option value="CLIENT">CLIENT</option>
                          <option value="PROSPECT">PROSPECT</option>
                        </select> 
                    </div>
                    <div class="col-md-6 col-lg-3 mt-2">
                      <button
                        @click="clearFilter()"
                        type="button"
                        class="btn btn-secondary rounded mt-4"
                      >
                        Clear
                      </button>
                      <button
                        @click="getClients()"
                        type="button"
                        class="btn btn-primary rounded mt-4"
                      >
                        Filter
                      </button>
                    </div>
                  </form>
                </div>
              </div>
          </div>
        </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="history filter-list">
              <div class="table-responsive p-0">
                <div class="loader" v-if="loading"></div>
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th 
                        scope="col"
                        class="sort text-left"
                        v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'firstName'
                          ? 'sort-client-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'firstName'
                          ? 'sort-client-desc'
                          : '',
                        ]"
                        @click="sort('firstName')"
                      >User</th>
                      <th 
                        scope="col"
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'userType'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'userType'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('userType')"
                     >Type</th>
                      <th
                          scope="col"
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'email'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'email'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('email')">Email</th>
                      <th
                        scope="col"
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'phone'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'phone'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('phone')">Phone</th>
                      <th
                        scope="col"
                      class="sort text-left"
                    >Spread</th>
                      <th v-if="isAdmin">
                        Assigned Rep
                      </th>
                      <th 
                         scope="col"
                      class="sort text-left"
                      v-bind:class="[
                      sortOrder == 'ASC' && sortColumn == 'status'
                        ? 'sort-client-asc'
                        : '',
                      sortOrder == 'DESC' && sortColumn == 'status'
                        ? 'sort-client-desc'
                        : '',
                      ]"
                      @click="sort('status')"
                      v-if="isAdmin">
                        Status
                      </th>

                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="list no-cursor">
                    <div class="loader" v-if="loading"></div>
                    <tr v-if="clients.length == 0 && !loading">
                      <td>
                        <p class="nodata text-white">No data available</p>
                      </td>
                    </tr>
                    <tr v-for="data in clients" :key="data.id">
                      <td class="text-left">
                        <span class="client-name"
                          >{{ data.firstName }} {{ data.lastName }}</span
                        >
                      </td>
                      <td class="text-left">{{ data.userType }}</td>
                      <td class="text-left">{{ data.email }}</td>
                      <td class="text-left">{{ data.phone }}</td>
                      <td class="text-left">
                        <input
                          type="text"
                          style="width: 100px"
                          class="form-control client-select form-control-sm"
                          v-model="data.spread"
                          :disabled="data.status == 'INVITED'"
                          placeholder="Enter Spread"
                        />
                      </td>
                      <td class="text-left" v-if="isAdmin">
                        <select
                          style="width: 200px"
                          class="form-control client-select form-control-sm"
                          v-model="data.clientRepId"
                          :disabled="data.status == 'INVITED'"
                        >
                          <option value="" disabled selected>Select Rep</option>
                          <option
                            v-for="rep in representatives"
                            :key="rep.id"
                            :value="rep.id"
                          >
                            {{ rep.firstName }} {{ rep.lastName }}
                          </option>
                        </select>
                      </td>
                      <td class="text-left" v-if="isAdmin">
                        <span
                          v-bind:class="
                            data.status == 'ACTIVE'
                              ? 'text-success'
                              : data.status == 'INVITED'
                              ? 'text-warning'
                              : 'text-danger'
                          "
                          >{{
                            data.status == 'ACTIVE'
                              ? 'ACTIVE'
                              : data.status == 'INVITED'
                              ? 'INVITED'
                              : 'INACTIVE'
                          }}</span
                        >
                      </td>

                      <td class="text-center invt">
                        <button
                          :disabled="!data.spread && !data.clientRepId"
                          class="btn btn-primary btn-sm mt-2"
                          @click="assignToRep(data)"
                        >
                          <i class="fa fa-save"></i> SAVE
                        </button>

                        <button
                          v-if="isAdmin"
                          :disabled="!data.clientRepId"
                          class="btn btn-warning btn-sm mt-2"
                          @click="removeRep(data)"
                        >
                          <i class="fa fa-unlink"></i> UNASSIGN REP
                        </button>
                        <div class="d-inline-flex mt-2" v-if="isAdmin || isRep">
                          <div class="dropdown">
                            <button
                              style="
                                background: #fff;
                                width: 25px;
                                height: 25px;
                              "
                              class="mt-2 btn ibtn blk dropdown-toggle mt-1"
                              type="button"
                              id="dropdownMenu2"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <i
                                class="fas fa-ellipsis-v"
                                style="font-size: 13px"
                              ></i>
                            </button>
                            <div
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenu2"
                            >
                              <button
                                type="button"
                                @click="changeStatus('DEACTIVE', data)"
                                class="dropdown-item"
                                title="Deactivate"
                              >
                                <!-- <span class="far fa-times-circle mr-1 mt-3"></span> -->
                                <div class="mt-1 ml-2">DEACTIVATE USER</div>
                              </button>
                              <button
                                type="button"
                                @click="openEditUserPopup(data)"
                                class="dropdown-item"
                                title="Edit User"
                              >
                                <!-- <span class="far fa-edit mr-1 mt-3"></span> -->
                                <div class="mt-1 ml-2">EDIT USER</div>
                              </button>
                              <button
                                type="button"
                                @click="sendPasswordResetEmail(data)"
                                class="dropdown-item"
                                title="Send Password Reset Email"
                              >
                                <!-- <span class="far fa-envelope mr-1 mt-3"></span> -->
                                <div class="mt-1 ml-2">SEND PASSWORD RESET EMAIL</div>
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- <button
                          :disabled="!data.clientRepId"
                          class="btn btn-primary btn-sm mt-2"
                          @click="assignToRep(data)"
                        >
                          <i class="fa fa-save"></i> SAVE
                        </button>
                        <button
                          v-if="isAdmin"
                          :disabled="!data.clientRepId"
                          class="btn btn-danger btn-sm mt-2"
                          @click="removeRep(data)"
                        >
                          <i class="fa fa-trash"></i> REMOVE REP
                        </button>
                       
                        <button
                          class="btn btn-secondary btn-sm mt-2"
                          @click="showClientModal()"
                        >
                          <i class="fa fa-edit"></i> EDIT
                        </button>
                        <button
                          class="btn btn-secondary btn-sm mt-2"
                          
                        >
                          <i class="fa fa-edit"></i> ACTIVATE
                        </button>
                         <button
                          class="btn btn-secondary btn-sm mt-2"
                          
                        >
                          <i class="fa fa-edit"></i> DEACTIVATE
                        </button>
                         -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-flex align-items-center mt-4 position-relative">
              <div class="d-flex align-items-center pagination-wrap">
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getClients(currentPage)"
              ></b-pagination>
              <span class="ml-2 total-records-client">{{ currentPage }} of {{ totalPageSize }} pages</span>
              </div>
              <div class="total-records-client ml-auto">
                <span>Total Records : {{ totalRows }}</span>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Modal for create client -->
    <div
      class="modal black"
      style="display: none"
      id="createClientModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create New User</h5>
            <div class="action">
              <a @click="hideClientModal()" aria-label="Close"
                ><i class="fa fa-times"></i
              ></a>
            </div>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-row">
                <div class="form-group col-md-6 required">
                  <label for="inputEmail4 ">First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputEmail4"
                    v-model="userObj.firstName"
                  />
                </div>
                <div class="form-group col-md-6 required">
                  <label for="inputPassword4">Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    id="inputPassword4"
                    v-model="userObj.lastName"
                  />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="inputEmail4">Phone Number</label>
                  <vue-phone-number-input
                  v-if="showPhoneInput"
                    name="phone"
                    v-model="userObj.phone"
                    :only-countries="['US']"
                    :no-country-selector="true"
                    @update="phoneNumberChanged"
                  />
                  <!-- <input type="text" @input="acceptNumber" class="form-control" id="inputEmail4" v-model="userObj.phone"> -->
                </div>
                <div class="form-group col-md-6 required">
                  <label for="inputAddress">Email</label>
                  <input
                    :disabled="userEditFlag"
                    type="email"
                    class="form-control"
                    id="inputAddress"
                    v-model="userObj.email"
                  />
                  <small id="emailHelp" class="form-text text-muted"
                    ><i class="fas fa-info-circle"></i> User can login using
                    this Email Address</small
                  >
                </div>
                <div class="form-group col-md-6 required">
                  <label for="inputAddress">Type</label>
                  <select class="form-control" v-model="userObj.userType">
                    <option value="CLIENT">Client</option>
                    <option value="PROSPECT">Prospect</option>
                  </select>
                </div>
                <div
                  class="alert alert-danger d-flex justify-content-center w-100 mt-4"
                  role="alert"
                  v-if="error"
                >
                  {{ error }}
                </div>
                <div class="d-flex justify-content-center w-100 mt-4">
                  <div class="modal-footer bid">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      @click="hideClientModal()"
                    >
                      Cancel
                    </button>
                    <button
                      v-if="!userEditFlag"
                      type="button"
                      class="btn btn-primary"
                      @click="createUser(userObj)"
                    >
                      Add
                    </button>
                    <button
                      v-if="userEditFlag"
                      type="button"
                      class="btn btn-primary"
                      @click="updateUser(userObj)"
                    >
                      Update
                    </button>
                  </div>
                  <div class="loader" v-if="userLoadingFlag"></div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from '@/config'
import authService from '@/authService'
export default {
  data () {
    return {
      clients: [],
      allClients: [],
      representatives: [],
      loading: false,
      searchText: '',
      isAdmin: false,
      isRep: false,
      userObj: { location: '', userType: 'CLIENT' },
      userEditFlag: false,
      error: '',
      userLoadingFlag: false,
      showFilters: false,
      clientType: '',
      selectedClient: null,
      showPhoneInput: false,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      totalPageSize: 0,
      sortColumn: 'firstName',
      sortOrder: 'ASC'
    }
  },
  methods: {
    sendPasswordResetEmail(user){
      var message = "Are you sure you want to send password reset email to the "+user.firstName+" "+user.lastName+" ("+user.email+")?";
      this.$confirm(message,"","question").then(() => {
          let dataToSend = {"email": user.email ,"resetByUserId": authService.getUser().id}
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http.put(config.baseUrlAutoBidder +"/user/reset-pwd",dataToSend,auth)
        .then(() => {
            this.$alert("Password reset email sent successfully.","","success");
        }).catch(() => {
            this.$alert("Something went wrong.","","error");
        });
      }).catch(() => {
          //console.log("cancelled")
      });
    
    },
  
     sort(column) {
      this.sortColumn = column;
      this.sortOrder =
        this.sortOrder == "ASC"
          ? (this.sortOrder = "DESC")
          : (this.sortOrder = "ASC");
      this.getClients();
    },
    clearFilter () {
      this.searchText = ''
      this.clientType = ''
      this.selectedClient = null
      this.getClients()
    },
    openEditUserPopup (user) {
      this.userObj = { ...user }
      this.formattedNumber = user.phone
      this.userEditFlag = true
      this.showClientModal('edit')
    },
    changeStatus (status, user) {
      this.$confirm(
        'Are you sure you want to change the status of this user?',
        'Confirmation',
        'warning'
      ).then(() => {
        this.loading = true
        var userObj = {
          id: user.id,
          status: status
        }

        console.log(userObj)
        const auth = {
          headers: {
            authorization: this.accessToken,
            'org-token': authService.getOrgToken()
          }
        }
        this.userFlag = true
        this.$http
          .put(config.baseUrlBidSide + '/user/status', userObj, auth)
          .then(() => {
            this.getClients()
            this.$alert('User status changed successfully', '', 'success')
            this.loading = false
          })
          .catch(e => {
            console.log(e)
            this.loading = false
          })
      })
    },
    createUser (user) {
      this.error = false
      if (!user.firstName) {
        this.error = 'First name is required'
        return false
      }
      if (!user.lastName) {
        this.error = 'Last name is required'
        return false
      }
      // if (!user.phone) {
      //   this.error = "Phone number is required";
      //   return false;
      // }
      if (!user.email) {
        this.error = 'Email is required'
        return false
      }
      if (!this.validateEmail(user.email)) {
        this.error = 'You have entered an invalid email address!'
        return false
      }
      // if (this.formattedNumber == null) {
      //   this.error = "Invalid phone number";
      //   return false;
      // }

      user.location = 'Office'

      this.userLoadingFlag = true
      let dataToSend = { ...user }
      dataToSend.phone = this.formattedNumber
      dataToSend.createdBy = authService.getUser().id

      if(this.isRep && !this.isAdmin){
        dataToSend.clientRepId = authService.getUser().id
      }
      // dataToSend.userType = 'CLIENT'
      const auth = {
        headers: {
          authorization: this.accessToken,
          'org-token': authService.getOrgToken()
        }
      }
      this.$http
        .post(config.baseUrlBidSide + '/user', dataToSend, auth)
        .then(response => {
          this.addRole(response.data.id)
        })
        .catch(e => {
          this.$alert(e.response.data)
          this.userLoadingFlag = false
          
        })
    },
    updateUser (user) {
      this.error = false
      if (!user.firstName) {
        this.error = 'First name is required'
        return false
      }
      if (!user.lastName) {
        this.error = 'Last name is required'
        return false
      }
      // if (!user.phone) {
      //   this.error = "Phone number is required";
      //   return false;
      // }
      if (!user.email) {
        this.error = 'Email is required'
        return false
      }
      if (!this.validateEmail(user.email)) {
        this.error = 'You have entered an invalid email address!'
        return false
      }
      // if (this.formattedNumber == null) {
      //   this.error = "Invalid phone number";
      //   return false;
      // }

      user.location = 'Office'

      this.userLoadingFlag = true
      let dataToSend = { ...user }
      dataToSend.phone = this.formattedNumber
      // dataToSend.userType = 'CLIENT'
      const auth = {
        headers: {
          authorization: this.accessToken,
          'org-token': authService.getOrgToken()
        }
      }
      this.$http
        .put(config.baseUrlBidSide + '/user', dataToSend, auth)
        .then(() => {
          this.$alert('User Updated Successfully', '', 'success')
          this.getClients()
          this.userLoadingFlag = false
          this.hideClientModal()
        })
        .catch(e => {
          this.$alert(e.response.data)
          this.userLoadingFlag = false
        })
    },
    addRole (userId) {
      var roleObj = { userId: userId, groups: ['Drl-Client'] }
      const auth = {
        headers: {
          authorization: this.accessToken,
          'org-token': authService.getOrgToken()
        }
      }
      this.$http
        .post(config.baseUrlBidSide + '/user/groups', roleObj, auth)
        .then(() => {
          this.$alert('User Added Successfully', '', 'success')
          this.getClients()
          this.userLoadingFlag = false
          this.hideClientModal()
        })
    },
    validateEmail (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    phoneNumberChanged (obj) {
      this.formattedNumber = obj.isValid ? obj.formattedNumber : null
    },
    showClientModal (mode) {
      if (mode !== 'edit') {
        this.userObj = { location: '', userType: 'CLIENT' }
      }
      this.showPhoneInput = true

      window.$('#createClientModal').modal('show')
    },
    hideClientModal () {
      this.showPhoneInput = false
      window.$('#createClientModal').modal('hide')
    },
    removeRep (client) {
      let dataToSend = { userId: client.id }
      const auth = {
        headers: {
          authorization: this.accessToken,
          'org-token': authService.getOrgToken()
        }
      }
      this.$http
        .put(config.baseUrlAutoBidder + '/user/unassignRep', dataToSend, auth)
        .then(() => {
          this.$alert(
            'Representative removed from client successfully',
            '',
            'success'
          )
          this.getClients()
        })
        .catch(e => {
          console.log(e)
        })
    },
    assignToRep (client) {
      let dataToSend = { ...client }
      const auth = {
        headers: {
          authorization: this.accessToken,
          'org-token': authService.getOrgToken()
        }
      }
      this.$http
        .put(config.baseUrlBidSide + '/user', dataToSend, auth)
        .then(() => {
          this.$alert(
            'Saved successfully',
            '',
            'success'
          )
        })
        .catch(e => {
          console.log(e)
        })
    },

    getClients () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url = ''
      // if(this.selectedClient){
      //   this.searchText = this.selectedClient.firstName + ' ' + this.selectedClient.lastName
      // } else {
      //   this.searchText = ''
      // }
      if (this.isRep && !this.isAdmin) {
        url =
          config.baseUrlAutoBidder +
          '/user/client-list?page=' + this.currentPage + '&size=' + this.perPage + '&search=' + this.searchText + '&status=ACTIVE,INVITED&sortColumn=' + this.sortColumn + '&sortOrder=' + this.sortOrder + '&clientRepId=' +
          authService.getUser().id + '&userType=' + this.clientType
      } else {
        url =
          config.baseUrlBidSide +
          '/user/list?page=' + this.currentPage + '&size=' + this.perPage + '&search=' + this.searchText + '&status=ACTIVE,INVITED&sortColumn=' + this.sortColumn + '&sortOrder=' + this.sortOrder + '&group=Drl-Client&userType=' + this.clientType
      }
      this.$http
        .get(url, auth)
        .then(result => {
          this.clients = result.data.content
          this.totalRows      = result.data.pageInfo.totalElements
          this.totalPageSize  = result.data.pageInfo.totalPageSize
          console.log("total rows", this.totalRows)
          console.log("total page size", this.totalPageSize)
          this.loading = false
        })
        .catch(e => {
          console.log(e)
          this.loading = false
        })
    },
    getAllClients () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      let url = ''
      if (this.isRep && !this.isAdmin) {
        url =
          config.baseUrlAutoBidder +
          '/user/client-list?page=1&size=1000&search=' + this.searchText + '&status=ACTIVE,INVITED&sortColumn=firstName&sortOrder=ASC&clientRepId=' +
          authService.getUser().id + '&userType=' + this.clientType
      } else {
        url =
          config.baseUrlBidSide +
          '/user/list?page=1&size=1000&search=' + this.searchText + '&status=ACTIVE,INVITED&sortColumn=firstName&sortOrder=ASC&group=Drl-Client&userType=' + this.clientType
      }
      this.$http
        .get(url, auth)
        .then(result => {
          this.allClients = [...result.data.content.map(user => {
            return {
              ...user,
              clientFullName: user.firstName + ' ' + user.lastName
            }
          })] 
          

          this.loading = false
        })
        .catch(e => {
          console.log(e)
          this.loading = false
        })
    },

    
    getRepresentatives () {
      this.loading = true
      const auth = {
        headers: { 'org-token': authService.getOrgToken() }
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            '/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Rep',
          auth
        )
        .then(result => {
          this.representatives = result.data.content
          this.getClients()
        })
        .catch(e => {
          console.log(e)
          this.loading = false
        })
    }
  },
  created () {
    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log('accessToken is not found', err)
      } else {
        this.tenantName = role[0].split('-')[0]
        var roleArray = role.map(item => {
          return item.split('-')[1]
        })
        roleArray.includes('Rep') ? (this.isRep = true) : (this.isRep = false)
        roleArray.includes('Admin')
          ? (this.isAdmin = true)
          : (this.isAdmin = false)
        roleArray.includes('Client')
          ? (this.isClient = true)
          : (this.isClient = false)

        //Tem set rep to admin privilage.
        if(this.isRep){
          this.isAdmin = true
        }
        if (this.isAdmin) {
          this.getRepresentatives()
        } else {
          this.getClients()
        }
        this.getAllClients()
      }
    })
  },
  mounted () {
    this.$root.$on('onsearch', searchText => {
      this.searchText = searchText
      this.getClients()
    })
  },
  beforeDestroy () {
    this.$root.$off('onsearch')
  }
}
</script>
<style scoped>
.client-select {
  background: #272641;
  border: 1px solid #373455;
  box-shadow: none;
  border-radius: 5px;
  outline: none;
  color: #fff;
  font-weight: 400;
  font-size: 13px;
  display: block;
  width: 100%;
}
.loader {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.1);
  border-top-color: #4c6fff; /* soft neon blue */
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin: auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.black i {
  background: none !important;
  border: none !important;
}
.invt .dropdown .dropdown-item {
  /* background: #272641 !important; */
  color: #fff !important;
  padding: 0 !important;
}
.invt .dropdown .dropdown-item:hover {
  background: #373455 !important;
  color: #fff !important;
}
</style>
